var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0979 5.46802L12.8479 2.03052C12.7556 1.97975 12.652 1.95312 12.5467 1.95312C12.4413 1.95312 12.3377 1.97975 12.2454 2.03052L5.99543 5.46802C5.89744 5.52197 5.81572 5.60124 5.75881 5.69754C5.7019 5.79384 5.67188 5.90365 5.67188 6.01552C5.67188 6.12738 5.7019 6.23719 5.75881 6.3335C5.81572 6.4298 5.89744 6.50907 5.99543 6.56302L11.9217 9.82239V16.5218L10.0242 15.478L9.42168 16.5724L12.2454 18.1255C12.3377 18.1764 12.4413 18.2031 12.5467 18.2031C12.652 18.2031 12.7557 18.1764 12.8479 18.1255L19.0979 14.688C19.196 14.6341 19.2777 14.5548 19.3347 14.4585C19.3916 14.3622 19.4217 14.2524 19.4217 14.1405V6.01552C19.4217 5.90364 19.3916 5.79381 19.3347 5.6975C19.2777 5.6012 19.196 5.52195 19.0979 5.46802ZM12.5467 3.29177L17.4998 6.01552L12.5467 8.73927L7.59356 6.01552L12.5467 3.29177ZM18.1717 13.7711L13.1717 16.5211V9.82177L18.1717 7.07177V13.7711Z",
    fill: "#9C4900",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 10.0781H1.92188V8.82812H6.92188V10.0781ZM8.17188 15.0781H3.17188V13.8281H8.17188V15.0781ZM9.42188 12.5781H4.42188V11.3281H9.42188V12.5781Z",
    fill: "#9C4900",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatch);
export default __webpack_public_path__ + "static/media/dispatch.a43e0c9b66a99e4cb828badaa29346e8.svg";
export { ForwardRef as ReactComponent };